
angular.module('EICDataStream3.dashboard', ['adf', 'adf.structures.base',
  "ngResource", "ui.directives",
  'ui.bootstrap',
  "EICDataStream3.userData",
  // 'ui.multiselectWidgets',
  "ivpusic.cookie",
  "EICDataStream3.resources",
  'sample.widgets.repeatLastSearch',
  'sample.widgets.savedSearches',
  'sample.widgets.recentlyAddedProjects',
  'sample.widgets.recentlyAwardedContracts',
  //'sample.widgets.favouriteLists',
  'sample.widgets.quickFindProject',
  'sample.widgets.numberOfProjectsChart',
  'sample.widgets.assetAnalysisChart',
  'sample.widgets.recentlyAddedAssets',
  'sample.widgets.newSearch',
  // 'sample.widgets.twitter' - removed at  Neil's request at JDM 24 Feb 2015
]) //,
  .constant('defaultDashboardModel', {
    "title": " ",
    "structure": "5-7",
    "selectedWidgets": [
      { "id": "newSearch", "name": "New Search (Projects or Contract Awards)" },
      { "id": "repeatLastSearch", "name": "Repeat Last Search" },
      { "id": "savedSearches", "name": "Saved Project/Contract Award Searches" },
      { "id": "recentlyAddedProjects", "name": "Recently Added Projects" },
      { "id": "recentlyAwardedContracts", "name": "Recently Awarded Contracts" },
      { "id": "quickFindProject", "name": "Quickly Locate a Project by Name or ID" },
      { "id": "numberOfProjectsChart", "name": "Projects In EICDataStream" },
      { "id": "asset-analysis-chart", "name": "Assets in EICAssetMap" },
      { "id": "recently-added-assets", "name": "Recently Added Assets" }
    ],
    "rows": [
      {
        "columns": [
          {
            "styleClass": "col-md-5",
            "widgets": [
              { "type": "newSearch", "config": {}, "title": "New Search (Projects or Contract Awards)" },
              { "type": "recentlyAwardedContracts", "config": {}, "title": "Recently Awarded Contracts" },
              { "type": "recentlyAddedProjects", "config": {}, "title": "Recently Added Projects" },
              { "type": "repeatLastSearch", "config": {}, "title": "Repeat Last Search" }
            ]
          },
          {
            "styleClass": "col-md-7",
            "widgets": [
              { "type": "savedSearches", "config": {}, "title": "Saved Project/Contract Award Searches" },
              { "type": "numberOfProjectsChart", "config": {}, "title": "Projects In EICDataStream" },
              { "type": "asset-analysis-chart", "config": {}, "title": "Assets in EICAssetMap" },
              { "type": "recently-added-assets", "config": {}, "title": "Recently Added Assets" },
              { "type": "quickFindProject", "config": {}, "title": "Quickly Locate a Project by Name or ID" },
            ]
          }
        ]
      }
    ]

  })
  .controller('DashboardController', ['$scope', '$rootScope', 'dashboard', 'dashboardDataService', 'dashboardValidator', 'defaultDashboardModel', 'userAccessService', 'DASHBOARD_CONFIG', 'featuresService',
    function ($scope, $rootScope, dashboard, dashboardDataService, dashboardValidator, defaultDashboardModel, userAccessService, DASHBOARD_CONFIG, featuresService) {
      $scope.dashboard = dashboard;

      var ASSET_ANALYSIS_WIDGET_ID = 'asset-analysis-chart';
      var RECENTLY_ADDED_ASSETS_WIDGET_ID = 'recently-added-assets';
      var NEW_SEARCH_WIDGET_ID = 'newSearch';
      var REPEAT_LAST_SEARCH_WIDGET_ID = 'repeatLastSearch';
      var SAVED_SEARCHES_WIDGET_ID = 'savedSearches';
      var RECENTLY_ADDED_PROJECTS_WIDGET_ID = 'recentlyAddedProjects';
      var RECENTLY_AWARDED_CONTRACTS_WIDGET_ID = 'recentlyAwardedContracts';
      var QUICK_FIND_PROJECT_WIDGET_ID = 'quickFindProject';
      var NUMBER_OF_PROJECTS_CHART_WIDGET_ID = 'numberOfProjectsChart';
      var CAPEX_WIDGET_ACCESS_GROUP = 'CAPEX';
      var OPEX_WIDGET_ACCESS_GROUP = 'OPEX';
      var REQUIRED_ASSET_ANALYSIS_ACCESS = 'eicassetmap/opex';
      var isDashboardEnabledForAssetMap = !!(DASHBOARD_CONFIG && DASHBOARD_CONFIG.enableDashboardForEicAssetMap);
      var isAssetAnalysisChartEnabledByConfig = !!(DASHBOARD_CONFIG && DASHBOARD_CONFIG.enableAssetAnalysisChart);
      var isRecentlyAddedAssetsEnabledByConfig = !!(DASHBOARD_CONFIG && DASHBOARD_CONFIG.enableRecentlyAddedAssetsWidget);
      var widgetAccessGroups = {};
      widgetAccessGroups[NEW_SEARCH_WIDGET_ID] = CAPEX_WIDGET_ACCESS_GROUP;
      widgetAccessGroups[REPEAT_LAST_SEARCH_WIDGET_ID] = CAPEX_WIDGET_ACCESS_GROUP;
      widgetAccessGroups[SAVED_SEARCHES_WIDGET_ID] = CAPEX_WIDGET_ACCESS_GROUP;
      widgetAccessGroups[RECENTLY_ADDED_PROJECTS_WIDGET_ID] = CAPEX_WIDGET_ACCESS_GROUP;
      widgetAccessGroups[RECENTLY_AWARDED_CONTRACTS_WIDGET_ID] = CAPEX_WIDGET_ACCESS_GROUP;
      widgetAccessGroups[QUICK_FIND_PROJECT_WIDGET_ID] = CAPEX_WIDGET_ACCESS_GROUP;
      widgetAccessGroups[NUMBER_OF_PROJECTS_CHART_WIDGET_ID] = CAPEX_WIDGET_ACCESS_GROUP;
      widgetAccessGroups[ASSET_ANALYSIS_WIDGET_ID] = OPEX_WIDGET_ACCESS_GROUP;
      widgetAccessGroups[RECENTLY_ADDED_ASSETS_WIDGET_ID] = OPEX_WIDGET_ACCESS_GROUP;
      var canUseAssetAnalysisChart = false;
      var canUseRecentlyAddedAssetsWidget = false;
      var hasCapexAccess = false;
      var hasOpexAccess = false;
      var lastComputedAccessDetails = {};

      var getWidgetDecision = function (widgetId) {
        var accessGroup = getWidgetAccessGroup(widgetId);
        var hasAccessForGroup = accessGroup === OPEX_WIDGET_ACCESS_GROUP ? hasOpexAccess : hasCapexAccess;
        var flagAllowed = true;

        if (widgetId === ASSET_ANALYSIS_WIDGET_ID) {
          flagAllowed = canUseAssetAnalysisChart;
        }
        else if (widgetId === RECENTLY_ADDED_ASSETS_WIDGET_ID) {
          flagAllowed = canUseRecentlyAddedAssetsWidget;
        }

        return {
          widgetId: widgetId,
          accessGroup: accessGroup,
          hasAccessForGroup: hasAccessForGroup,
          flagAllowed: flagAllowed,
          allowed: hasAccessForGroup && flagAllowed
        };
      };

      var createDashboardAccessLog = function (context, details) {
        return {
          context: context,
          product: featuresService && featuresService.product ? featuresService.product.fullName : null,
          hasCapexAccess: hasCapexAccess,
          hasOpexAccess: hasOpexAccess,
          canUseAssetAnalysisChart: canUseAssetAnalysisChart,
          canUseRecentlyAddedAssetsWidget: canUseRecentlyAddedAssetsWidget,
          details: angular.extend({}, lastComputedAccessDetails, details || {}),
          widgetDecisions: []
        };
      };

      var isAssetMapProduct = function () {
        var product = featuresService && featuresService.product ? featuresService.product : {};
        var descriptor = [product.prefix, product.name, product.fullName]
          .filter(function (value) { return !!value; })
          .join(' ')
          .toLowerCase();

        return descriptor.indexOf('assetmap') >= 0;
      };

      var isDataStreamProduct = function () {
        var product = featuresService && featuresService.product ? featuresService.product : {};
        var descriptor = [product.prefix, product.name, product.fullName]
          .filter(function (value) { return !!value; })
          .join(' ')
          .toLowerCase();

        return descriptor.indexOf('datastream') >= 0;
      };

      var applyDashboardTitleTemplateByProduct = function (dashboardModel) {
        if (!dashboardModel) return;

        delete dashboardModel.titleTemplateUrl;
        dashboardModel.showTitleTemplateOnly = false;
      };


      var widgetName = function (field) {
        return function (widget) {
          return widget[field];
        };
      };


      var notIn = function (list) {
        return function (widget) {
          return list.indexOf(widget.id) < 0;
        }
      }

      var getWidgetAccessGroup = function (widgetId) {
        return widgetAccessGroups[widgetId] || CAPEX_WIDGET_ACCESS_GROUP;
      };

      var hasAccessForWidget = function (widgetId) {
        var accessGroup = getWidgetAccessGroup(widgetId);
        return accessGroup === OPEX_WIDGET_ACCESS_GROUP ? hasOpexAccess : hasCapexAccess;
      };

      var isWidgetAllowed = function (widgetId) {
        return getWidgetDecision(widgetId).allowed;
      };

      var filterDashboardModelByWidgetAccess = function (dashboardModel) {
        if (!dashboardModel) return;

        dashboardModel.selectedWidgets = (dashboardModel.selectedWidgets || []).filter(function (widget) {
          var widgetId = widget && widget.id ? widget.id : null;
          return widgetId ? isWidgetAllowed(widgetId) : false;
        });

        (dashboardModel.rows || []).forEach(function (row) {
          (row.columns || []).forEach(function (column) {
            column.widgets = (column.widgets || []).filter(function (widget) {
              var widgetType = widget && widget.type ? widget.type : null;
              return widgetType ? isWidgetAllowed(widgetType) : false;
            });
          });
        });
      };

      var applyWidgetAvailabilityByAccess = function () {
        var dashboardAccess = createDashboardAccessLog('selector');

        if (dashboard.widgets) {
          Object.keys(dashboard.widgets).forEach(function (widgetId) {
            var decision = getWidgetDecision(widgetId);
            dashboardAccess.widgetDecisions.push(decision);

            if (!decision.allowed) {
              delete dashboard.widgets[widgetId];
            }
          });
        }

        console.log('[DashboardAccess]', dashboardAccess);

        filterDashboardModelByWidgetAccess(defaultDashboardModel);

        if ($scope.model) {
          filterDashboardModelByWidgetAccess($scope.model);
        }
      };

      var removeAssetAnalysisChartFromModel = function (dashboardModel) {
        if (!dashboardModel || !dashboardModel.rows || dashboardModel.rows.length === 0) return;

        dashboardModel.selectedWidgets = (dashboardModel.selectedWidgets || []).filter(function (widget) {
          return widget.id !== ASSET_ANALYSIS_WIDGET_ID;
        });

        dashboardModel.rows[0].columns[0].widgets = (dashboardModel.rows[0].columns[0].widgets || []).filter(function (widget) {
          return widget.type !== ASSET_ANALYSIS_WIDGET_ID;
        });

        dashboardModel.rows[0].columns[1].widgets = (dashboardModel.rows[0].columns[1].widgets || []).filter(function (widget) {
          return widget.type !== ASSET_ANALYSIS_WIDGET_ID;
        });
      };

      var removeRecentlyAddedAssetsFromModel = function (dashboardModel) {
        if (!dashboardModel || !dashboardModel.rows || dashboardModel.rows.length === 0) return;

        dashboardModel.selectedWidgets = (dashboardModel.selectedWidgets || []).filter(function (widget) {
          return widget.id !== RECENTLY_ADDED_ASSETS_WIDGET_ID;
        });

        dashboardModel.rows[0].columns[0].widgets = (dashboardModel.rows[0].columns[0].widgets || []).filter(function (widget) {
          return widget.type !== RECENTLY_ADDED_ASSETS_WIDGET_ID;
        });

        dashboardModel.rows[0].columns[1].widgets = (dashboardModel.rows[0].columns[1].widgets || []).filter(function (widget) {
          return widget.type !== RECENTLY_ADDED_ASSETS_WIDGET_ID;
        });
      };

      var hasRequiredAssetAnalysisAccess = function (accessData) {
        var strings = [];

        var flattenStrings = function (node) {
          if (!node) return;

          if (typeof node === 'string') {
            strings.push(node.trim().toLowerCase());
            return;
          }

          if (Array.isArray(node)) {
            node.forEach(flattenStrings);
            return;
          }

          if (typeof node === 'object') {
            Object.keys(node).forEach(function (key) {
              if (typeof key === 'string' && key.trim() !== '') {
                strings.push(key.trim().toLowerCase());
              }
              flattenStrings(node[key]);
            });
          }
        };

        flattenStrings(accessData);

        var hasFullAccessToken = strings.some(function (value) {
          return value === REQUIRED_ASSET_ANALYSIS_ACCESS ||
            value === 'eicassetmap:opex' ||
            value === 'eicassetmap-opex' ||
            value === 'eicassetmap opex' ||
            (value.indexOf('eicassetmap') >= 0 && value.indexOf('opex') >= 0);
        });

        if (hasFullAccessToken) return true;

        var hasAssetMapToken = strings.some(function (value) {
          return value === 'eicassetmap' ||
            value.indexOf('eicassetmap') >= 0 ||
            value.indexOf('assetmap') >= 0;
        });

        var hasOpexToken = strings.some(function (value) {
          return value === 'opex' || value.indexOf('opex') >= 0;
        });

        return hasAssetMapToken && hasOpexToken;
      };

      var hasOpexAccessFromFullDetails = function (payload) {
        var full = payload && payload.data ? payload.data : payload;
        var effectivePermissions = full && full.effectivePermissions ? full.effectivePermissions : null;
        var opexPermission = null;

        if (effectivePermissions && typeof effectivePermissions === 'object') {
          Object.keys(effectivePermissions).forEach(function (key) {
            if (!opexPermission && String(key).toUpperCase() === 'OPEX') {
              opexPermission = effectivePermissions[key];
            }
          });
        }

        var accessType = opexPermission && opexPermission.accessType ? opexPermission.accessType : null;

        if (!accessType || typeof accessType !== 'string') return false;

        var normalised = accessType.trim().toLowerCase();
        return normalised !== '' && normalised !== 'none' && normalised !== 'noaccess';
      };

      var hasCapexAccessFromFullDetails = function (payload) {
        var full = payload && payload.data ? payload.data : payload;
        var effectivePermissions = full && full.effectivePermissions ? full.effectivePermissions : null;
        var capexPermission = null;

        if (effectivePermissions && typeof effectivePermissions === 'object') {
          Object.keys(effectivePermissions).forEach(function (key) {
            if (!capexPermission && String(key).toUpperCase() === 'CAPEX') {
              capexPermission = effectivePermissions[key];
            }
          });
        }

        var accessType = capexPermission && capexPermission.accessType ? capexPermission.accessType : null;

        if (!accessType || typeof accessType !== 'string') return false;

        var normalised = accessType.trim().toLowerCase();
        return normalised !== '' && normalised !== 'none' && normalised !== 'noaccess';
      };

      var applyAssetAnalysisChartAvailability = function () {
        if (canUseAssetAnalysisChart) return;

        if (dashboard.widgets && dashboard.widgets[ASSET_ANALYSIS_WIDGET_ID]) {
          delete dashboard.widgets[ASSET_ANALYSIS_WIDGET_ID];
        }

        removeAssetAnalysisChartFromModel(defaultDashboardModel);

        if ($scope.model) {
          removeAssetAnalysisChartFromModel($scope.model);
        }
      };

      var applyRecentlyAddedAssetsAvailability = function () {
        if (canUseRecentlyAddedAssetsWidget) return;

        if (dashboard.widgets && dashboard.widgets[RECENTLY_ADDED_ASSETS_WIDGET_ID]) {
          delete dashboard.widgets[RECENTLY_ADDED_ASSETS_WIDGET_ID];
        }

        removeRecentlyAddedAssetsFromModel(defaultDashboardModel);

        if ($scope.model) {
          removeRecentlyAddedAssetsFromModel($scope.model);
        }
      };

      var initializeDashboard = function () {
        createWidgetList();
        loadUserDashboard();
      };

      var initializeWidgetAccess = function () {
        var fromRightsPromise = isAssetAnalysisChartEnabledByConfig
          ? userAccessService.getRights()
            .then(function (response) {
              return hasRequiredAssetAnalysisAccess(response.data);
            })
            .catch(function () {
              return false;
            })
          : Promise.resolve(false);

        var fromFullDetailsPromise = userAccessService.getFullDetails()
          .then(function (response) {
            return {
              hasOpex: hasOpexAccessFromFullDetails(response.data),
              hasCapex: hasCapexAccessFromFullDetails(response.data)
            };
          })
          .catch(function () {
            return {
              hasOpex: false,
              hasCapex: true
            };
          });

        Promise.all([fromRightsPromise, fromFullDetailsPromise])
          .then(function (results) {
            var hasCombinedFromRights = results[0] === true;
            var isAssetMapSession = isAssetMapProduct();
            var allowAssetWidgetsByDashboardFlag = !isAssetMapSession || isDashboardEnabledForAssetMap;
            hasOpexAccess = results[1].hasOpex === true || hasCombinedFromRights;
            hasCapexAccess = results[1].hasCapex === true;

            canUseAssetAnalysisChart = allowAssetWidgetsByDashboardFlag && isAssetAnalysisChartEnabledByConfig && hasOpexAccess;
            canUseRecentlyAddedAssetsWidget = allowAssetWidgetsByDashboardFlag && isRecentlyAddedAssetsEnabledByConfig && hasOpexAccess;

            lastComputedAccessDetails = {
              hasCombinedFromRights: hasCombinedFromRights,
              isAssetMapSession: isAssetMapSession,
              allowAssetWidgetsByDashboardFlag: allowAssetWidgetsByDashboardFlag,
              isDashboardEnabledForAssetMap: isDashboardEnabledForAssetMap,
              isAssetAnalysisChartEnabledByConfig: isAssetAnalysisChartEnabledByConfig,
              isRecentlyAddedAssetsEnabledByConfig: isRecentlyAddedAssetsEnabledByConfig
            };
          })
          .finally(function () {
            applyAssetAnalysisChartAvailability();
            applyRecentlyAddedAssetsAvailability();
            applyWidgetAvailabilityByAccess();
            initializeDashboard();
          });
      };


      $scope.$watch("model.selectedWidgets", function (newVal, oldVal) {
        // if the dashboard has not yet been set up, bail
        if (!newVal || !oldVal) return;

        var newIds = newVal.map(widgetName("id"));
        var oldIds = oldVal.map(widgetName("id"));


        // The rest of this is pretty horrible - there must be a better way than this
        // We are watching the selected widgets collection for changes
        // If an item is added, we dispatch to $scope.widgetAdded
        // If an item is removed, we dispatch to $scope.widgetRemoved
        if (newIds.length < oldIds.length) {
          // stuff has been removed - find the differencees and remove them
          oldVal.filter(notIn(newIds))
            .forEach($scope.widgetRemoved);
        }
        else if (newVal.length > oldVal.length) {
          // stuff has been added - find the differencees and add them
          newVal.filter(notIn(oldIds))
            .forEach($scope.widgetAdded);
        }
        // otherwise, no additions or removals

      });


      // Listen for the right  combination(s) of events.
      // The events emitted are (some may  never be seen owing to the way 
      // I am handling edits):
      //    'adfWidgetMovedInColumn'
      //    'adfWidgetAddedToColumn'
      //    'adfWidgetRemovedFromColumn'
      //    'adfWidgetAdded', name, model, widget
      //    'adfWidgetEnterEditMode', widget
      //    'adfIsEditMode'
      //    'adfDashboardChanged', name, model
      //    'adfDashboardCollapseExpand',{collapseExpandStatus : collapseExpandStatus} collapse all
      //    'adfDashboardEditsCancelled'
      //    'adfWidgetRemovedFromColumn'
      //    'widgetReload'
      //    'widgetConfigChanged'


      // The dashboard framework also acts upon the following hooks:
      //    'adfToggleEditMode'
      //    'widgetConfigChanged'
      //    'widgetReload'
      //    'adfDashboardCollapseExpand', event, args
      //    'adfWidgetEnterEditMode', event, widget


      $scope.$on('adfWidgetMovedInColumn', function () {
        dashboardDataService.saveDashboard($scope.model);
      });


      $scope.$on('adfWidgetRemovedFromColumn', function () {
        dashboardDataService.saveDashboard($scope.model);
      });


      $scope.$on('adfWidgetAddedToColumn', function () {
        dashboardDataService.saveDashboard($scope.model);
      });


      $scope.$on('adfDashboardCollapseExpand', function (evt, args) {
        var i = args.collapseExpandStatus;
      });

      // If a change is made to  the collapsed status of one of 
      // the widgets, this event fires.
      // use this evemt if you need to  know which widget was changed
      // and its current ststus
      // $scope.$on("widgetCollapseStateChanged", function (evt, args) {
      // });


      // When a change is made, the status bubbles up through the
      // affected column and row. If you need the latest state of 
      // the model (eg. for saving the dashboard model), but don't 
      // care which actual widget was alterd, use this event.
      // This event fires *after* "widgetCollapseStateChanged"
      $scope.$on('adfWidgetCollapseExpand', function () {

        // if ($scope.model.rows[0].collapsed) {
        //   // all widgets are collapsed
        // }
        // else {
        //   // one or more widgets are open
        // }

        dashboardDataService.saveDashboard($scope.model);
      });


      $scope.widgetAdded = function (widget) {
        if (!isWidgetAllowed(widget.id)) {
          return;
        }

        // special processing when a widget is added

        // ensure that  the widget is not already on the dashboard
        var wn = $scope.model.rows[0].columns[0].widgets.concat($scope.model.rows[0].columns[1].widgets)
          .map(widgetName("type"))
          .find(function (widgetID) {
            return widget.id === widgetID;
          });

        if (!wn) {
          var w = {
            type: widget.id,
            config: createConfiguration(widget.id),
            styleClass: defaultDashboardModel.widgetHeadingClass,
            title: widget.name || widget.title || widget.id
          };

          var col0Widgets = $scope.model.rows[0].columns[0].widgets || [];
          var col1Widgets = $scope.model.rows[0].columns[1].widgets || [];
          var targetColumnWidgets = col0Widgets.length <= col1Widgets.length ? col0Widgets : col1Widgets;
          targetColumnWidgets.unshift(w);

          dashboardDataService.saveDashboard($scope.model);
        }
      };


      $scope.widgetRemoved = function (widget) {
        // special processing when a widget is removed
        // look for the column and index of the required widget
        // and remove it

        // toDo: find a mor general way of doing filtering columns
        $scope.model.rows[0].columns[0].widgets = $scope.model.rows[0].columns[0].widgets.filter(w => w.type != widget.id);
        $scope.model.rows[0].columns[1].widgets = $scope.model.rows[0].columns[1].widgets.filter(w => w.type != widget.id);

        dashboardDataService.saveDashboard($scope.model);
        // $scope.$broadcast("close", {widgetID: widget.id});
      };


      function createConfiguration(type) {
        var cfg = {};
        var config = dashboard.widgets[type].config;
        if (config) {
          cfg = angular.copy(config);
        }
        return cfg;
      }


      // this has to be done first - it is an iife
      var createWidgetList = function () {
        // This is an interface method that takes an object structure
        // and turns it into a list of widget names
        $scope.dashboard.allWidgets = Object.keys(dashboard.widgets)
          .filter(function (key) {
            return (dashboard.widgets.hasOwnProperty(key));
          })
          .map(function (key) {
            var widget = dashboard.widgets[key];
            return { id: widget.id, name: widget.title };
          });
      };


      // this has to be done next - it is another iife
      var loadUserDashboard = function () {
        dashboardDataService.loadDashboard()
          .then(dashboardValidator.validateAndRepair)
          .then(dashboardValidator.removeUnwantedKeys)
          .then(dashboardValidator.removeNonexistentWidgets($scope.dashboard.allWidgets))
          .then(function (dashboardModel) {
            applyDashboardTitleTemplateByProduct(dashboardModel);
            $scope.model = dashboardModel;
          });
      };

      initializeWidgetAccess();

    }])
  .service('dashboardDataService', ['$http', 'defaultDashboardModel',
    function ($http, defaultDashboardModel) {
      var service = this;

      service.loadDashboard = function () {
        // fetch model from the server
        var p = $http.get("/api/userDashboardModel")
          .then(getDashboard, getDefaultDashboard);

        return p
      };


      var getDashboard = function (response) {
        //var d = JSON.parse(response.data);
        var d = response.data;

        return d;
      };


      var getDefaultDashboard = function (errResponse) {
        if (errResponse.status === 401) {
          // unauthorised - don't want to  get the default
          // dashboard it it is an authentication problem as this will just corrupt it

          console.log("getDefaultDashboard: unauthorized - throwing errResponse");
          throw errResponse; // ?? is this the way to do it??
        }

        return defaultDashboardModel;
      };


      service.saveDashboard = function (dashboardModel) {
        var defaultDashboardTitleTemplate = '/app-ds3/dashboard/angular-dashboard-framework-0.12.0/templates/dashboard-title.html';
        var assetMapOnlyDashboardTitleTemplate = '/app-ds3/dashboard/angular-dashboard-framework-0.12.0/templates/dashboard-title-assetmap-only.html';
        var modelToSave = angular.copy(dashboardModel);
        var widCounter = 0;
        var ensureWidgetIds = function (model) {
          if (!model || !Array.isArray(model.rows)) return;

          model.rows.forEach(function (row) {
            if (!row || !Array.isArray(row.columns)) return;

            row.columns.forEach(function (column) {
              if (!column || !Array.isArray(column.widgets)) return;

              column.widgets.forEach(function (widget) {
                if (!widget) return;

                if (widget.wid === undefined || widget.wid === null || widget.wid === '') {
                  widget.wid = 'wid-' + Date.now() + '-' + (widCounter++);
                }
              });
            });
          });
        };

        delete modelToSave.showTitleTemplateOnly;

        // Back-end requires titleTemplateUrl, but AssetMap-only message must remain runtime-only.
        if (!modelToSave.titleTemplateUrl || modelToSave.titleTemplateUrl === assetMapOnlyDashboardTitleTemplate) {
          modelToSave.titleTemplateUrl = defaultDashboardTitleTemplate;
        }

        ensureWidgetIds(modelToSave);

        return $http.post("/api/userDashboardModel", modelToSave) // angular.toJson()
          .catch(function (err) {
            console.error("Failed to save dashboard model", err);
          });
      };


      service.widgetColumn = function (dashboardModel, name) {
        var col0 = dashboardModel.rows[0].columns[0].widgets.find(function (widget) {
          return widget.type === name;
        });
        if (col0) return 0;

        var col1 = dashboardModel.rows[0].columns[1].widgets.find(function (widget) {
          return widget.type === name;
        });
        if (col1) return 1;

        return -1;
      };

    }])
  .service('dashboardValidator', ['defaultDashboardModel',
    function (defaultDashboardModel) {
      var service = this;

      // validateAndRepair :: dashboardModel -> dashboardModel
      var validateAndRepair = function (dashboardModel) {
        if (service.validate(dashboardModel))
          return dashboardModel;
        else
          return service.repair(dashboardModel);
      };

      //     function getDefaultModel() {
      //       return {
      //         title:           " ",
      //         structure:       "5-7",
      //         selectedWidgets: [
      //           //   {"id": "repeatLastSearch", "name": "Repeat Last Search (Re-run the most recent search you performed)"},
      //           //   {"id": "savedSearches", "name": "Saved Searches (Displays a list of saved searches)"},
      //           {"id": "recentlyAddedProjects"},
      //           {"id": "recentlyAwardedContracts"},
      //           {"id": "quickFindProject"},
      //           {"id": "numberOfProjectsChart"}
      //         ],
      //
      //
      //         rows: [
      //           {
      //             columns: [
      //               {
      //                 styleClass: "col-md-5",
      //                 widgets:    [
      //                   {
      //                     id:     "numberOfProjectsChart",
      //                     type:   "numberOfProjectsChart",
      //                     config: { }
      // //                      ,
      // //                      title:  "Repeat Last Search"
      //                   }
      // //                    {
      // //                      id: "repeatLastSearch",
      // //                      type:   "repeatLastSearch",
      // //                      config: { }
      // ////                      ,
      // ////                      title:  "Repeat Last Search"
      // //                    },
      // //                    {
      // //                      id: "savedSearches",
      // //                      type:   "savedSearches",
      // //                      config: { }
      // ////                      ,
      // ////                      title:  "Saved Searches"
      // //                    },
      // //                    {
      // //                      type:   "favouriteLists",
      // //                      config: {}
      // //
      // ////                      ,
      // ////                      title:  "Favourite Lists"
      // //                    }
      //                 ]
      //               },
      //               {
      //                 styleClass: "col-md-7",
      //                 widgets:    [
      //                   {
      //                     type:   "quickFindProject",
      //                     config: {}
      // //                      ,
      // //                      title:  "Quickly Locate a Project by Name"
      //                   },
      //                   {
      //                     type:   "recentlyAddedProjects",
      //                     config: {}
      // //                      ,
      // //                      title:  "Recently Added Projects"
      //                   },
      //                   {
      //                     type:   "recentlyAwardedContracts",
      //                     config: {}
      // //                      ,
      // //                      title:  "Recently Awarded Contracts"
      //                   }
      //                 ]
      //               }
      //             ]
      //           }
      //         ]
      //       };
      //     }
      //
      //     service.widgetColumn = function(dashboardModel, name){
      //       var col0 = dashboardModel.rows[0].columns[0].widgets.find(function(widget){
      //         return widget.type === name;
      //       });
      //       if(col0) return 0;
      //
      //       var col1 = dashboardModel.rows[0].columns[1].widgets.find(function(widget){
      //         return widget.type === name;
      //       });
      //       if(col1) return 1;
      //
      //       return -1;
      //     };

      var widgetName = function (field) {
        return function (widget) {
          return widget[field];
        };
      };


      service.validate = function (dashboardModel) {
        try {
          // check for existence of the rows. If there are no rows, validation fails
          if (!dashboardModel.rows || dashboardModel.rows.length === 0) return false;

          // check for existence of columns on the first row. If there are no columns, validation fails
          if (!dashboardModel.rows[0].columns || dashboardModel.rows[0].columns.length === 0) return false;

          // Check the style for row 1, col 1 - should be "col-md-5"
          if (dashboardModel.rows[0].columns[0].styleClass !== "col-md-5") return false;

          // Check the style for row 1, col 2 - should be "col-md-7"
          if (dashboardModel.rows[0].columns[1].styleClass !== "col-md-7") return false;

          // Structure Entry should exist and should be "5-7"        
          if (!dashboardModel.structure || dashboardModel.structure != "5-7") return false;

          // get selected list and concatenated column lists.
          var col0 = dashboardModel.rows[0].columns[0].widgets;
          var col1 = dashboardModel.rows[0].columns[1].widgets;
          var widgetDataNames = col0.concat(col1).map(widgetName("type"));

          // if lengths are different then validation automatically fails
          if (dashboardModel.selectedWidgets.length != widgetDataNames.length) return false;

          var selectedNames = dashboardModel.selectedWidgets.map(widgetName("id"))

          // subtract widget data names from selectedNames
          // there should be no material difference between the lists,
          // or validation fails
          var diff = selectedNames.filter(function (selectedName) {
            return widgetDataNames.indexOf(selectedName) < 0;
          });

          return (diff.length === 0);
        }
        catch (e) {
          return false;
        }

        return true;
      };


      service.repair = function (dashboardModel) {
        return defaultDashboardModel;
        // dashboardModel.structure = "5-7";
        // dashboardModel.rows = [
        //   {
        //     columns: [
        //       {
        //         styleClass: "col-md-5",
        //         widgets: []
        //       },
        //       {
        //         styleClass: "col-md-7",
        //         widgets: []
        //       }
        //     ]
        //   }
        // ];
        //
        // return dashboardModel;
      };


      // validateAndRepair :: dashboardModel -> dashboardModel
      service.validateAndRepair = function (dashboardModel) {
        if (service.validate(dashboardModel))
          return dashboardModel;
        else
          return service.repair(dashboardModel);
      };

      service.removeNonexistentWidgets = function (allWidgets) {
        var allWidgetIds = allWidgets.map(function (widget) { return widget.id; });

        var inCollection = function (propertyName) {
          return function (item) {
            return allWidgetIds.indexOf(item[propertyName]) >= 0;
          }
        };

        return function (dashboardModel) {
          dashboardModel.selectedWidgets = dashboardModel.selectedWidgets
            .filter(inCollection("id"));

          dashboardModel.rows[0].columns[0].widgets = dashboardModel.rows[0].columns[0].widgets
            .filter(inCollection("type"));


          dashboardModel.rows[0].columns[1].widgets = dashboardModel.rows[0].columns[1].widgets
            .filter(inCollection("type"));


          // dashboardModel.selectedWidgets = dashboardModel.selectedWidgets
          //   .filter(function (listItem) {
          //     return allWidgetIds.indexOf(listitem.id) >= 0;
          //   })
          //
          // dashboardModel.rows[0].columns[0].widgets = dashboardModel.rows[0].columns[0].widgets
          //   .filter(function (widget) {
          //     return allWidgetIds.indexOf(widget.type) >= 0;
          //   })
          //
          // dashboardModel.rows[0].columns[1].widgets = dashboardModel.rows[0].columns[1].widgets
          //   .filter(function (widget) {
          //     return allWidgetIds.indexOf(widget.type) >= 0;
          //   })

          return dashboardModel;
        }
      }

      service.removeUnwantedKeys = function (dashboardModel) {
        delete dashboardModel.titleTemplateUrl;
        delete dashboardModel.showTitleTemplateOnly;
        // delete d.title;

        var widgetHeadingClass = defaultDashboardModel.widgetHeadingClass || "panel-default";
        var assetAnalysisWidgetId = 'asset-analysis-chart';
        var assetAnalysisWidgetTitle = 'Assets in EICAssetMap';
        var savedSearchesWidgetId = 'savedSearches';
        var savedSearchesWidgetTitle = 'Saved Project/Contract Award Searches';

        if (Array.isArray(dashboardModel.selectedWidgets)) {
          dashboardModel.selectedWidgets.forEach(function (widget) {
            if (widget && widget.id === assetAnalysisWidgetId) {
              widget.name = assetAnalysisWidgetTitle;
            }
            if (widget && widget.id === savedSearchesWidgetId) {
              widget.name = savedSearchesWidgetTitle;
            }
          });
        }

        // when fetching the dashboard, ignore any saved template urls
        // these will prevent the correct termplates from being loaded 
        // Also add the configured heading style and colour to each widget
        dashboardModel.rows.forEach(row => {
          row.columns.forEach(col => {
            col.widgets.forEach(widget => {
              delete widget.titleTemplateUrl;
              delete widget.editTemplateUrl;

              if (widget.type === assetAnalysisWidgetId) {
                widget.title = assetAnalysisWidgetTitle;
              }
              if (widget.type === savedSearchesWidgetId) {
                widget.title = savedSearchesWidgetTitle;
              }

              delete widget.styleClass;
              widget.styleClass = " panel-primary widget-styling"

              // setup widget.collapsed property to default to false if undefined
              if (typeof widget.collapsed === 'undefined') widget.collapsed = false;
            });
          });
        });

        return dashboardModel;
      }
    }]);
